import { Component } from 'react';
import { withRouter } from 'react-router';
import scrollIntoView from 'scroll-into-view-if-needed';

class ScrollToTop extends Component {

	componentDidUpdate() {
		if (this.props.history.action === 'PUSH') {
			scrollIntoView(this.props.scrollContainer.current, { behavior: 'smooth', block: 'start', scrollMode: 'if-needed' });
		}
	}

	render() {
		return this.props.children
	}
}

export default withRouter(ScrollToTop)
